import React, {Component} from 'react';
import {connect} from 'react-redux';
import DropZone from 'react-dropzone';
import cloneDeep from 'lodash/cloneDeep';
import Aspect from '../Helpers/Aspect';
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";

class ImageDrop extends Component {
  constructor(props) {
    super(props);
    this.state={
      drag_enter:false
    };
  }
  isImage(type) {
    return (/\/(gif|jpg|jpeg|tiff|png)$/i).test(type);
  }
  onDrop(accepted) {
    this.setState({ drag_enter:false });
    if(this.props.multiple) {
      let was=false;
      let cur=this.props.linker.value;
      if(!cur) {
        cur=[];
      }
      for(let i in accepted) {
        if(this.isImage(accepted[i].type)) {
          was=true;
          cur.push({ uploaded: accepted[i] });
        }
      }
      /*if(was) {
        this.props.valueLink.requestChange(cur);
      }*/

    } else {
      if (accepted[0] && this.isImage(accepted[0].type)) {
        accepted[0].old=toJS(this.props.linker.value);
        this.props.linker.value.uploaded=accepted[0];
      }
    }
  }
  componentWillUnmount() {
    if(this.props.multiple) {
      if (this.props.linker.value && this.props.linker.value.length) {
        this.props.linker.value.forEach((item)=>{
          if(item.preview) {
            window.URL.revokeObjectURL(item.preview);
          }
        });
      }
    } else {
      if (this.props.linker.value && this.props.linker.value.preview) {
        window.URL.revokeObjectURL(this.props.linker.value.preview);
        this.props.linker.value=null;
      }
    }
  }
  renderSingleInner() {
    if(this.props.already.linker.value.src) {
      const cur=this.props.already.linker.value;
      const markUnmark=()=>{
        cur.delete=cur.delete?0:1;
        /*console.log('cur',cur);
        this.props.already.linker.value=cur;*/
      };
      return (
        <div className={`pa hov pa-tl w100 h100 bg-w2`} style={{backgroundImage:`url('${cur.src}')`, backgroundPosition:'center center', backgroundRepeat:'no-repeat', backgroundSize:'contain'}}>
          {this.props.readonly?null:(
            <div className={`up12 padding h100 tac bg-w1-op50 ${cur.delete?"":"op-hov"}`}>
              <div className="cell s-12 s-middle">
                <div className="up12 margin">

                  <div className={`cell s-6 ${cur.delete?'bg-const2 w1':'bg-w1'} up12 splice rad5 pointer padd15`} onClick={()=>{ markUnmark(); }}>
                    {cur.delete?(
                      <div className="cell s-12 s-middle">
                        <i className="mdi mdi-trash lh10 fs20 const1"></i>
                        <div className="bold fs13">
                          File will deleted on save
                        </div>
                      </div>
                    ):(
                      <div className="cell s-12 s-middle">
                        <i className="mdi mdi-close lh10 fs20 const2"></i>
                        <div className="bold fs13">
                          Mark for delete
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="cell s-6 bg-w1 up12 splice rad5 pointer padd15">
                    <div className="cell s-12 s-middle">
                      <div className="mdi mdi-upload lh10 fs20 pc1 tac"></div>
                      <span className="pc1" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this._dropZoneRef.open(); }}>Upload another</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}
        </div>
      )
    } else {
      return null;
    }
  }
  renderDropHere() {
    return (
      <div className={`pa pa-tl w100 h100 dashed2 bo-w2 up12 splice ${this.state.drag_enter?'bg-const3-op20':'bg-w1-op20'}`}>
        <div className="cell s-12 s-middle tac">
          {this.props.translateStore.t.titles.drop_image_here}<br />
          <span className="pointer pc1" onClick={()=>{ this._dropZoneRef.open(); }}>{this.props.translateStore.t.titles.browse_image}</span>
        </div>
      </div>
    );
  }
  getAspect() {
    if (this.props.aspect.indexOf(':')>-1) {
      return this.props.aspect;
    } else {
      if (this.props.aspect.indexOf('x')>-1) {
        const ex=this.props.aspect.split("x");
        return `${ex[1]}:${ex[0]}`;
      }
    }
    return null;
  }
  onDeleteChange(delMe)
  {
    if(this.props.onDeleteChange) {
      this.props.onDeleteChange(delMe);
    }
  }
  getUploadedImageSrc(arr) {
    console.log("arrarr",toJS(arr));
    if(arr.uploaded) {
      return arr.uploaded.preview;
    }
    if(!arr.delete || this.props.multiple) {
      if (arr.path) {
        return arr.path;
      }
      if (arr.image) {
        return arr.image;
      }
      if (arr.src) {
        return arr.src;
      }
    }
    return null;
  }
  renderInner() {
    if(this.props.multiple) {
      return (
        <div style={{height:70}} className={`up12 splice bo-w2 dashed2 ${this.state.drag_enter?'bg-const3-op20':'bg-w1-op20'}`}>
          <div className="cell s-12 s-middle tac">
            {this.props.translateStore.t.titles.drop_images_here}<br />
            <span className="pointer pc1" onClick={()=>{ this._dropZoneRef.open(); }}>{this.props.translateStore.t.titles.browse_images}</span>
          </div>
        </div>
      )
    } else {
      const cancelTitle=this.props.linker.value?(this.props.linker.value.preview?'Cancel':'Delete'):'';

      return (
        <div style={{maxHeight:this.props.maxHeight, maxWidth:this.props.maxWidth}} className="pr ofh hov">
          <Aspect aspect={this.getAspect()} pa={true}>
            {this.state.drag_enter?this.renderDropHere():(
              this.getUploadedImageSrc(this.props.linker.value)?(
              <div className="pa pa-tl w100 h100 bg-w2"
                   style={{backgroundImage:`url('${this.getUploadedImageSrc(this.props.linker.value)}')`,
                     backgroundPosition:'center center',
                     backgroundRepeat:'no-repeat',
                     backgroundSize:'contain'}}>
                <div className="up12 splice h100 op-hov bg-w1-op50">
                  <div className="cell s-10 s-push-1 rad5 pointer padd15 bg-w1 s-middle tac" onClick={()=>{ if(this.props.linker.value.uploaded) { delete(this.props.linker.value.uploaded); } else { this.props.linker.value.delete=1; } }}>
                    <i className="mdi mdi-close lh10 fs20 const2 db tac"></i>
                    {cancelTitle}
                  </div>
                </div>
              </div>
            ):this.props.already && this.props.already.linker.value && this.props.already.linker.value.src?this.renderSingleInner():this.renderDropHere())}
          </Aspect>
        </div>
      )
    }
  }
  renderSelected() {
    if(this.props.multiple) {
      let alreadyItems=[];
      if(this.props.already && this.props.already.linker.value && this.props.already.linker.value.length) {
        alreadyItems=this.props.already.linker.value.map((item,index)=>{
          return (
            <div key={`already-${index}`} className="fl mright10 mbottom10 pointer hov pr" onClick={()=>{
              let cur=this.props.already.linker.value;
              if(cur[index].delete) {
                delete cur[index].delete;
              } else {
                cur[index].delete='1';
              }
              // this.props.already.linker.value=.requestChange(cur);
            }}>
              <img src={`/autoresize/0x70${item.src}`} style={{height: 70, opacity:item.delete?0.2:1}} />
              <div className="pa pa-tl op-hov bg-w1-op10 w100 h100 tac up12 splice transp03">
                {item.delete?(
                  <div className="cell s-12 s-middle">
                    <i className="mdi mdi-check lh10 fs20 const1"></i>
                    <div className="bold fs13">
                      unmark
                    </div>
                  </div>
                  ):(
                  <div className="cell s-12 s-middle">
                    <i className="mdi mdi-close lh10 fs20 const2"></i>
                    <div className="bold fs13">
                      mark for delete
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        });
      }
      let items=[];
      if(this.props.linker && this.props.linker.value && this.props.linker.value.length) {
        items=this.props.linker.value.map((item,index)=>{
          return (
            <div key={index} className="fl mright10 mbottom10 pointer hov pr" onClick={()=>{
              if(item.uploaded) {
                let cur = this.props.linker.value;
                let spliced = cur.splice(index, 1);
                window.URL.revokeObjectURL(spliced[0].preview);
              } else {
                if(item.delete) {
                  delete(item.delete);
                } else {
                  item.delete = 1;
                }
              }
              // this.props.valueLink.requestChange(cur);
            }}>
              <img src={this.getUploadedImageSrc(item)} style={{height: 70, opacity:item.delete?0.2:1}} />
              <div className="pa pa-tl op-hov bg-w1-op10 w100 h100 tac up12 splice transp03">
                <div className="cell s-12 s-middle">
                  <i className="mdi mdi-close lh10 fs20 const2"></i>
                  <div className="bold fs13">
                    {item.uploaded?'remove':(item.delete?'unmark':'mark for delete')}
                  </div>
                </div>
              </div>
            </div>
          )
        });
      }

      if(alreadyItems.length || items.length) {
        const itemsAll=(
          <div>
            {alreadyItems}{items}
            <div className="cb"></div>
          </div>
        );
        return this.props.renderWrapper?this.props.renderWrapper(itemsAll):itemsAll;
      }

    }
    return null;
  }
  render() {
    if(this.props.readonly) {
      return this.renderInner();
    }
    return (
      <div>
        {this.state.drag_enter}
        {this.renderSelected()}
        {this.props.disableUpload?null:(
          <DropZone preventDropOnDocument={true} disableClick={true} onDragEnter={()=>{ this.setState({ drag_enter:true }) }} onDragLeave={()=>{ this.setState({ drag_enter:false }); }} ref={(ref)=>{ this._dropZoneRef=ref; }} onDrop={this.onDrop.bind(this)} style={{}}>
            {this.renderInner()}
          </DropZone>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    t:state.translate,
  }
}

export default inject("translateStore")(observer(ImageDrop));
